import { Tooltip } from "@chakra-ui/react";
import React, { forwardRef, PropsWithChildren } from "react";

export const CustomTextTooltip = forwardRef<
  HTMLElement,
  PropsWithChildren<{ text: string; hide?: boolean }>
>(({ children, text, hide }, ref) => {
  const child = React.cloneElement(children as React.ReactElement, { ref });
  if (hide) return <>{child}</>;
  return <Tooltip label={text}>{child}</Tooltip>;
});

CustomTextTooltip.displayName = "CustomTextTooltip";
